import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_TAGS_APP_PATHS } from '../constants/tags-app-paths.constants';
import AdminTagsView from '../views/admin/AdminTags.view';

export default function AdminTagsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_TAGS_APP_PATHS.TAGS_LIST} component={AdminTagsView} />
    </React.Fragment>
  );
}
